import { createTransaction } from 'api/Shipment/api';
import { DELIVERY_TYPE_FROM_USER } from 'api/Shipment/constants';
import { setTransactions } from 'store/shipping/actions';
import { TranslationsKey } from 'i18nextOptions';
import { AmplitudeEvent } from 'common/constants/amplitude';

import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useAmplitude } from 'react-amplitude-hooks';

export const useGenerateLabel = () => {
  const { t } = useTranslation();
  const { logEvent } = useAmplitude();
  const dispatch = useDispatch();
  
  const [ error, setError ] = useState('');
  const [ isLoading, setLoading ] = useState(false);

  const generateLabel = () => {
    setLoading(true);
    setError('');
    createTransaction(DELIVERY_TYPE_FROM_USER)
      .then(({ data }) => {
        logEvent(AmplitudeEvent.SHIPPING_LABEL_GENERATED);
        
        if (data) {
          dispatch(setTransactions(data));
        }
      })
      .catch(error => setError(error?.response?.data?.message || t('errors.server_error_try_again')))
      .finally(() => setLoading(false));
  };
  
  return {
    generateLabel,
    isLoading,
    error,
  };
};

export const useLocalizedHaveKitFlow = () => {
  const { t } = useTranslation();

  const getLocalizedLabel = useCallback((label: string) => {
    return t(`dashboard.shipping.have_kit_status.label.${label}` as TranslationsKey);
  }, [ t ]);

  const getLocalizedDescription = useCallback((description: string) => {
    return t(`dashboard.shipping.have_kit_status.description.${description}` as TranslationsKey);
  }, [ t ]);

  return {
    getLocalizedLabel,
    getLocalizedDescription,
  };
};
